import Icon from './Icon';
// --- Footer Component ---
const Footer = () => (
    <footer className="bg-slate-900 border-t border-slate-800">
        <div className="container mx-auto px-6 py-8 flex flex-col md:flex-row justify-between items-center text-center md:text-left">
            <p className="text-slate-500 mb-4 md:mb-0">&copy; {new Date().getFullYear()} Alan Gerónimo. Crafted with passion.</p>
            <div className="flex space-x-6">
                 <a href="https://github.com/algeronimo92" target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-cyan-400 transition-colors"><Icon name="github" /></a>
                <a href="https://www.linkedin.com/in/alan-ger%C3%B3nimo-sanes-1b48b8153/" target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-cyan-400 transition-colors"><Icon name="linkedin" /></a>
                <a href="mailto:contacto@alangeronimo.com" className="text-slate-500 hover:text-cyan-400 transition-colors"><Icon name="mail" /></a>
            </div>
        </div>
    </footer>
);
export default Footer;